import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Please enter attribute type name.'),
  type: Yup.string().required('Please select attribute format.')
});
